/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var tileSource = _interopDefault(require('./tile-source'));

var XYZSource = __ol__.source.XYZ;
var methods = {
  /**
   * @return {ol.source.XYZ}
   * @protected
   */
  createSource: function createSource() {
    return new XYZSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      crossOrigin: this.crossOrigin,
      maxZoom: this.maxZoom,
      minZoom: this.minZoom,
      opaque: this.opaque,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      tileGrid: this._tileGrid,
      tilePixelRatio: this.tilePixelRatio,
      tileUrlFunction: this.createUrlFunc(),
      tileLoadFunction: this.tileLoadFunction,
      wrapX: this.wrapX,
      transition: this.transition
    });
  }
};

var watch = {};

var xyzSource = {
  mixins: [tileSource],
  methods: methods,
  watch: watch
};

module.exports = xyzSource;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/xyz-source.js
// module id = 103
// module chunks = 1